// dayjs-config.ts
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import utc from "dayjs/plugin/utc";

dayjs.extend(updateLocale);
dayjs.extend(utc);

// Force Monday as the first day of week globally
dayjs.updateLocale("en", {
  weekStart: 1, // Monday
});

// Export the patched instance (optional, for consistency)
export default dayjs;
